module.exports = __webpack_public_path__ + "img/texto.bfa7590c.svg";